import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import WhiteLabelQuery from '@/plugins/graphql/queries/v2/white-label-content.gql';
import WhiteLabelRedirectMixin from '@/helpers/mixins/WhiteLabelRedirectMixin';
let PhotoMixin = class PhotoMixin extends Mixins(WhiteLabelRedirectMixin) {
    constructor() {
        super(...arguments);
        this.whiteLabelContent = null;
    }
    featuredPhotoUrl(imageUrl) {
        if (process.env.NODE_ENV === 'development') {
            return this.fallbackPhotoUrl;
        }
        return imageUrl || this.fallbackPhotoUrl;
    }
    get fallbackPhotoUrl() {
        if (this.whiteLabelContent) {
            return this.whiteLabelContent.whiteLabelFavicon;
        }
        return require('@/assets/images/cg_logo.png');
    }
};
PhotoMixin = __decorate([
    Component({
        apollo: {
            whiteLabelContent: {
                query: WhiteLabelQuery,
                variables() {
                    return {
                        origin: this.getOrigin,
                    };
                },
                update(data) {
                    if (data.whiteLabelContent) {
                        return data.whiteLabelContent;
                    }
                    return null;
                },
            },
        },
    })
], PhotoMixin);
export default PhotoMixin;
